import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledConsentsAndAuthorizationsDocumentTemplateModal = styled(StyledFlex)`
   height: 100vh;
`;

StyledConsentsAndAuthorizationsDocumentTemplateModal.displayName =
   'StyledConsentsAndAuthorizationsDocumentTemplateModal';
